import { version } from 'shared/constants';
import { UAParser } from 'ua-parser-js';

export const collectMetadata = (): Record<
  string,
  string | number | boolean
> => {
  const parser = new UAParser();
  const browser = parser.getBrowser();
  const os = parser.getOS();

  return {
    url: window.location.href,
    browser: `${browser.name} ${browser.version}`,
    os: `${os.name} ${os.version}`,
    screenSize: `${window.screen.width}x${window.screen.height}`,
    appVersion: version,
  };
};
